<template>
  <v-row>
    <v-col cols="12">
      <CatalogHeader />
    </v-col>
    <v-col cols="12">
      <CatalogCategories v-if="id == 'categories'" />
      <ProductsList v-if="id == 'products'" />
      <CatalogTemplates v-else-if="id == 'templates'" />
      <CatalogDesignGroups v-else-if="id == 'designgroups'" />
      <CatalogIndustries v-else-if="id == 'industries'" />
      <CatalogTopics v-else-if="id == 'topics'" />
      <CatalogMissingTemplates v-else-if="id == 'missing-templates'" />
      <CatalogCopyTemplates v-else-if="id == 'copy-templates'" />
      <CatalogReplaceTemplates v-else-if="id == 'replace-templates'" />
      <Tasks
        v-if="id == 'projects'"
        show-all
      />
    </v-col>
  </v-row>
</template>

<script>
import CatalogCategories from '@/components/catalog/Categories';
import CatalogCopyTemplates from '@/components/catalog/CopyTemplates';
import CatalogDesignGroups from '@/components/catalog/DesignGroups';
import CatalogHeader from '@/components/catalog/Header';
import CatalogIndustries from '@/components/catalog/Industries';
import CatalogMissingTemplates from '@/components/catalog/MissingTemplates';
import CatalogReplaceTemplates from '@/components/catalog/ReplaceTemplates';
import CatalogTemplates from '@/components/catalog/Templates';
import CatalogTopics from '@/components/catalog/Topics';
import ProductsList from '@/components/products/List';
import Tasks from '@/components/tasks/List';
export default {
  name: 'CatalogDetail',
  components: {
    CatalogHeader,
    ProductsList,
    CatalogCategories,
    CatalogTemplates,
    CatalogDesignGroups,
    CatalogIndustries,
    CatalogTopics,
    CatalogMissingTemplates,
    CatalogCopyTemplates,
    CatalogReplaceTemplates,
    Tasks
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('lookup/getCategories'),
      this.$store.dispatch('lookup/getDesignGroups'),
      this.$store.dispatch('lookup/getDesigners'),
      this.$store.dispatch('lookup/getProducts'),
      this.$store.dispatch('lookup/getIndustries'),
      this.$store.dispatch('lookup/getTopics'),
      this.$store.dispatch('catalog/filter', { page: 1 })
    ]);
  }
};
</script>
